import { render, staticRenderFns } from "./TheMailTrackingImport.vue?vue&type=template&id=71b590e5&scoped=true&lang=pug&"
import script from "./TheMailTrackingImport.vue?vue&type=script&lang=js&"
export * from "./TheMailTrackingImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b590e5",
  null
  
)

export default component.exports